import Store from '../../../interfaces/Store';
import update from 'immutability-helper';
import { Dimensions } from '../../../interfaces/Dimensions';

export const setDimensionsReducer = (state: Store, dimensions: Dimensions): Store =>
  update(state, {
    configuration: {
      dimensions: {
        $set: dimensions
      }
    }
  });
